<section *ngIf="processing">
    <h2>{{processingMessage}}...</h2>
    <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
    </mat-progress-bar>
  </section>

  <section *ngIf="!processing">
    <mat-card fxFlex="100" fxFlex.lt-sm="100" >
      <mat-card-title>
        <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
          <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
            <span style="font-size: larger"><mat-icon>attach_file</mat-icon> Attach {{attachment.letterType}} Letter <span *ngIf="voucher != undefined && voucher != null">{{voucher?.voucherId}}</span></span>
          </div>
          <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
            <button mat-button mat-dialog-close="Cancel" mat-raised-button color="basic" aria-label="Cancel">Cancel</button>
          </div>
        </div>
        <hr/>
      </mat-card-title>
      <mat-card-content>
        <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="16px">
          <div fxLayout="column" fxFlex="75">
            <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload />
            <div fxLayout="column" fxLayoutGap="16px">
              <div fxLayout="row" fxLayoutGap="8px">
                <div class="file-upload">
                  <button mat-raised-button color="primary" class="upload-btn" (click)="fileUpload.click()" [disabled]="filename != null && filename.length > 0">
                    Select File
                    <mat-icon>attach_file</mat-icon>
                  </button>
                </div>
                <div fxLayout="column" fxLayoutGap="8px">
                  <button mat-raised-button color="accent" (click)="uploadFile()" [disabled]="filename == null || filename.length == 0">
                    Upload
                  </button>
                </div>
              </div>
              <div fxLayout="row" fxLayoutGap="8px" *ngIf="filename != null && filename.length > 0">
                <span style="font-size: large;">File:&nbsp;</span>
                  <span>{{ filename }}</span>&nbsp;<mat-icon color="warn" (click)="removeStagedFile()">delete</mat-icon>
                  <span fxFlex></span>
              </div>
            </div>
            
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </section>

